import React, { Component } from "react";
import { connect } from "react-redux";
import ComponentHeader from "../common/ComponentHeader";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { getAllOccassionDataApi } from "./Api";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, formatDate, isModuleExist } from "../../utils/Constant";
import { InformationModal, VerifiedModal } from "../common";
import { toast } from "react-toastify";
import { OCCASSION_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { deleteAuthCommonApi } from "../content/Api";
import editPencil from "../../assets/images/edit-icon.png";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";



class Occassion extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.AutoShareOccassion);

    this.state = {
      access: AccesData,
      search: "",
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,


      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''

    };
  }


  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllOccassionDataApi(this);

  }

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;


    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;

    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllOccassionDataApi(this);

      });
    }
  }

  // getDetailsUser = (data) => {
  //     this.props.history({ pathname: `/platform/details/${data?.uuid}`, state: { "id": data?.uuid } });
  // }

  showEditModal = (rowData = null) => {
    this.props.history({ pathname: `/occassion/add-occassion`, state: { data: rowData } })
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };

  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };

  deleteHandle = async (id) => {
    const res = await deleteAuthCommonApi(`/occassion/${id}`);
    // console.log(res)
    if (res.status === 200) {
      this.props.getAllOccassionDataApi(this);
      this.setState({
        delete: !this.state.delete
      });

    } else {
      toast.error("Somthis wrong...")
    }
  }

  render() {
    const { access } = this.state;

    const { occassionData, totalPages, currentPage } = this.props.autoShareState;
    // console.log(eventData)
    return (
      <>

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.occasionName}?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.occasionName}'`}
          show={this.state.show}
          url={OCCASSION_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllOccassionDataApi(this) }}
        />
        <section>
          <ComponentHeader
            title="Occassion"
            primaryBtn={access.createAccess ? "Add Occassion" : ""}
            // isSearch={true}
            breadcrumb={[["Auto Share", "/auto-share"], ["Occassion", ""]]}
            placeholder="Search Occassion Name"
            onChangeMethod={(value) => {

              this.setState({ search: value?.search })
              this.props.history({
                pathname: this.props.location.pathname,
                search: `?p=${this.state.currentPage || START_PAGE}&search=${value?.search}`,
              });
              this.props.getAllOccassionDataApi(this);
            }}
            // isBackArrow={true}
            // isReturn="/contentCollections"
            handlePrimaryBtn={() => { this.props.history('/occassion/add-occassion') }}
          />
          <Row>
            <Col sm={2}>
              <FilterVefiedDropDown ctx={this} />
            </Col>
          </Row>
          <div className="commom-table-wrapper">
            <CustomTable
            ctx={this}
              data={occassionData?.list}
              columns={[
                {
                  width: 200,
                  title: "Occassion Name",
                  dataIndex: "occasionName",
                  className: "occassionName",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.occasionName;
                  },
                },
                {
                  width: access.verificationAccess ? 120 : 0,
                  title: "Verified",
                  dataIndex: "isVerified",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                   const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                  },
                },
                {
                  width: 200,
                  title: "Date",
                  dataIndex: "date",
                  className: "",
                  isCell: true,
                  render:(text, rowData, dataKey) => {

                      const dates = rowData?.date?.split(",");
                      if (Array.isArray(dates) && dates.length > 0) {
                        return dates.map(item => formatDate(item)).join(", ");
                      }
                      return "N/A";
                  },
                },

                {

                  width: access.updateAccess || access.deleteAccess ? 90 : 0,
                  title: "Action",
                  dataIndex: "",
                  className: "",
                  fixed: "right",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return (
                        <div className="d-flex gap-4 justify-content-around">

                          {access.updateAccess && (
                            <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />
                          )}
                          {access.deleteAccess && (
                            <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                          )}
                        </div>
                      );
                  },

                }

              ]}
              
              total={occassionData?.length || 0}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  autoShareState: state.AutoShareState,
});
const mapDispatchToProps = {
  getAllOccassionDataApi,
  deleteAuthCommonApi

};
Occassion.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Occassion));
